<div class="v4-layout-block" *ngIf="listOfAccount?.length || searching">
  <div class="channel-title v4-layout-block-title">
    {{ "channel-account-base_account_html_关联的账号" | translate }}
    <!-- Connected Accounts -->
  </div>

  <div class="v4-layout-block-content">
    <div class="channel-filter-bar flex flex-row items-center justify-between pb-[30px]">
      <div class="v4-filter-list" [formGroup]="searchForm">
        <div class="v4-filter-item">
          <v4-widget-input
            formControlName="username"
            [placeholder]="'placeholder.account_name' | translate"></v4-widget-input>
        </div>
        <div class="v4-filter-item">
          <host-select
            class="v4-filter-style"
            formControlName="thirdparty_type"
            [defaultValue]="null"
            [listOfOption]="optionsOfChannel"
            [placeholder]="'placeholder.channel' | translate"></host-select>
        </div>
      </div>
      <ng-content select=".base-account-list_filter-right"></ng-content>
    </div>

    <v4-common-account-list
      [listOfAccount]="listOfAccount"
      [total]="total"
      [page]="page"
      [pageSize]="pageSize"
      (onPageChange)="onPageChange($event)"
      (onDeleteAccount)="onClickDeleteAccount($event)"
      (onReconnect)="onClickReconnect($event)"
      (onChangePassword)="onClickChangePassword($event)"
      (onSyncListings)="syncAccountHouse($event)"
      (onCtripChangeUsername)="onClickChangeCtripUsername($event)"
      (onTongchengAddProperties)="onClickTongchengAddProperties($event)"></v4-common-account-list>
  </div>
</div>
